import React from 'react';
import {
  FDBox,
} from '@facet-wealth/design';
import DataContainer from 'Components/UI/DataContainer';
import {
  useItemListContext,
} from 'Views/Page/Content/Templates/GenericTableTemplate/MainContent/ItemListPicker/ItemList/ItemContext';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import PlannerTransitionTable
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTable';
import PlannerTransitionPageHeader
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionPageHeader';

const PlannerTransitionHouseholdContent = ({ plannerTransitionHouseholdPageResource }) => {
  const {
    loadingError: plannerTransitionHouseholdSummaryLoadingError,
    itemsCollection: plannerTransitionHouseholdSummaryCollection,
  } = useItemListContext();

  return (
    <FDBox>
      <PlannerTransitionPageHeader plannerTransitionHouseholdPageResource={plannerTransitionHouseholdPageResource} />
      <DataContainer
        component={PlannerTransitionTable}
        loading={!plannerTransitionHouseholdSummaryCollection}
        loadingError={plannerTransitionHouseholdSummaryLoadingError}
      />
    </FDBox>
  );
};

PlannerTransitionHouseholdContent.defaultProps = {
};

PlannerTransitionHouseholdContent.propTypes = {
  plannerTransitionHouseholdPageResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default PlannerTransitionHouseholdContent;
